(function () {
  "use strict";
  if (window.__rvaFlow2Send) return;
  window.__rvaFlow2Send = 1;

  var TBD = "TBD",
    MAIL = "orders@rvathreads.com",
    THANKS = "/pages/thank-you-page",
    FLAG = "rvaReqSending";

  var ICON_ART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 16V4"/><path d="M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>';
  var ICON_BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';

  function $(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function money(n) { return typeof window.money === "function" ? window.money(+n || 0) : "$" + (+n || 0).toFixed(2); }
  function count(n, one, many) { return n + " " + (n === 1 ? one : many); }
  function isReq() { return !!$("reqPage"); }
  function St() { return window.S; }
  function warn(e) { try { console.warn("rva-flow2-send", e); } catch (x) {} }
  function pcs(line) {
    var n = 0;
    (window.SIZES || []).forEach(function (z) { n += +line.sizes[z] || 0; });
    return n;
  }
  function tbdAll() {
    var n = 0;
    (St().req || []).forEach(function (l) { n += +l.sizes[TBD] || 0; });
    return n;
  }
  function wrap(name, make) {
    var f = window[name];
    if (typeof f !== "function" || f.rvaFlow2Send) return false;
    var g = make(f);
    for (var k in f) if (Object.prototype.hasOwnProperty.call(f, k)) g[k] = f[k];
    g.rvaFlow2Send = 1;
    window[name] = g;
    return true;
  }
  function styleOf(line) { return typeof window.styleById === "function" ? window.styleById(line.id) : null; }
  function photo(st, color, cls) {
    try { return window.photo(st, color, cls); } catch (e) { return ""; }
  }
  function total() { try { return window.reqPieces(); } catch (e) { return 0; } }

  function tbdNote() {
    var card = document.querySelector("#rSum .rCard"), send = $("send");
    if (!card || !send) return;
    var n = tbdAll(), el = $("rfTbdSum");
    if (!n) { if (el && el.parentNode) el.parentNode.removeChild(el); return; }
    if (!el) {
      el = document.createElement("p");
      el.id = "rfTbdSum";
      el.className = "rfTbdSum";
    }
    var h = "<b>" + count(n, "piece has", "pieces have") + " sizes to come.</b> That&#39;s fine. Send it now and we&#39;ll get the sizes from you before we invoice.";
    if (el.innerHTML !== h) el.innerHTML = h;
    if (send.previousElementSibling !== el) send.parentNode.insertBefore(el, send);
  }
  function tidySummary() {
    var box = $("rSum"), card = box && box.querySelector(".rCard");
    if (!card) return;
    var keep = card.querySelector(".keepRow");
    if (keep && !keep.closest(".rfKeep")) {
      var d = document.createElement("details");
      d.className = "rfKeep";
      d.innerHTML = "<summary>Save or share this request</summary>";
      keep.parentNode.insertBefore(d, keep);
      d.appendChild(keep);
    }
    var art = card.querySelector(".dArt"), send = $("send");
    if (art) {
      art.className = "dArt rfArtMini";
      art.innerHTML = ICON_ART + "<span><b>Next:</b> your name, email and artwork. No art yet? You can send it later.</span>";
      if (send && send.nextElementSibling !== art) send.parentNode.insertBefore(art, send.nextSibling);
    }
    var k = card.querySelector(".rfKeep"), nt = card.querySelector("details.dNote");
    if (k && nt && k.nextElementSibling !== nt) nt.parentNode.insertBefore(k, nt);
    tbdNote();
  }

  function zipOK() {
    var el = $("rZip");
    if (!el) return true;
    var v = String(el.value || "");
    return !/\d/.test(v) || /^\s*\d{5}(?:-?\d{4})?\s*$/.test(v);
  }

  var F = { open: false, pushed: false, y: 0, src: "", touched: false, first: 0, lastLoad: 0, lastMsg: 0, t: 0, done: false, sendingOn: false, h1: "", lede: "" };

  function frameURL() {
    var u = window.submitURL();
    return u + (u.indexOf("?") < 0 ? "?" : "&") + "isIframeEmbed=1&parentURL=" + encodeURIComponent(location.origin + location.pathname);
  }
  function recapHTML() {
    var S = St(), e = total();
    var tax = "";
    try {
      tax = S.exempt ? "Tax exempt" : window.reqTax() > 0 ? "Includes 6% Virginia sales tax" : "No Virginia sales tax";
    } catch (x) {}
    var items = S.req.map(function (l) {
      var st = styleOf(l);
      if (!st) return "";
      var parts = [];
      (window.SIZES || []).forEach(function (z) {
        if (z !== TBD && +l.sizes[z] > 0) parts.push(l.sizes[z] + " " + z);
      });
      if (+l.sizes[TBD] > 0) parts.push(l.sizes[TBD] + " sizes to come");
      return '<li><span class="rfRPic">' + photo(st, l.color, "phSm") + '</span><span class="rfRTxt"><b>' + esc(st.b + " " + st.s) + "</b><span>" + esc(l.color[0]) + " &middot; " + count(pcs(l), "piece", "pieces") + "</span><span>" + esc(parts.join(", ")) + "</span></span></li>";
    }).join("");
    var spec = "";
    try { spec = window.inkSpec(); spec = spec.charAt(0).toUpperCase() + spec.slice(1); } catch (x) {}
    return '<div class="rfRecapTop"><span class="rfRecapK">Your request</span><button class="rfEdit" type="button" data-rf-back>Edit</button></div>' +
      '<details class="rfRecapD"' + (window.matchMedia && window.matchMedia("(max-width: 899px)").matches ? "" : " open") + ">" +
      "<summary><span>" + count(e, "piece", "pieces") + '</span><b>' + money(window.reqGrand()) + "</b></summary>" +
      '<ul class="rfRecapList">' + items + "</ul></details>" +
      '<div class="rfRecapTot"><span>' + esc(spec) + "</span><span>" + esc(tax) + "</span></div>" +
      (tbdAll() ? '<p class="rfRecapNote"><b>Sizes to come:</b> we&#39;ll ask for them before we invoice.</p>' : "") +
      '<p class="rfRecapNote">Nothing is charged now. We email you an invoice with your final price, and paying it places your order.</p>';
  }
  function buildSend() {
    var w = $("rfSendWrap");
    if (w) return w;
    var root = $("rvaCat");
    w = document.createElement("div");
    w.className = "wrap rfSendWrap";
    w.id = "rfSendWrap";
    w.hidden = true;
    w.innerHTML = '<section class="rfSend" aria-labelledby="rfSendH">' +
      '<button class="rfBack" type="button" data-rf-back>' + ICON_BACK + "<span>Back to your request</span></button>" +
      '<div class="rfSendGrid"><div class="rfSendMain">' +
      '<h2 class="rfSendH" id="rfSendH" tabindex="-1">Your details and artwork</h2>' +
      '<div class="rfArt"><span class="rfArtIc">' + ICON_ART + "</span><div><p><b>Attach your artwork in the form below.</b> Vector files (.ai, .eps, .pdf, .svg) print best. A high-resolution .png works too.</p>" +
      '<p><b>No art yet?</b> Send your request anyway and email the art to <a href="mailto:' + MAIL + '">' + MAIL + "</a> when it&#39;s ready.</p></div></div>" +
      '<div class="rfFrameBox"><p class="rfLoading" id="rfLoading">Loading the form&hellip;</p><iframe id="rfFrame" title="Send your quote request" scrolling="no" allow="geolocation; microphone; camera; fullscreen" src="about:blank"></iframe></div>' +
      "</div>" +
      '<aside class="rfRecap" id="rfRecap"></aside></div></section>';
    var main = $("reqPage") && $("reqPage").closest(".wrap");
    if (main && main.parentNode) main.parentNode.insertBefore(w, main.nextSibling);
    else (root || document.body).appendChild(w);
    var fr = $("rfFrame");
    fr.addEventListener("load", onFrameLoad);
    w.addEventListener("click", function (ev) {
      if (ev.target.closest("[data-rf-back]")) { ev.preventDefault(); closeSend(false); }
    });
    return w;
  }
  /* After the customer sends, Jotform redirects the frame to the thank-you page, which cannot load inside a frame.
     Hide the frame and show "Sending" right away; sent() then moves the whole page to the thank-you page.
     If the frame turns out to be a normal form reload (it sends a message), put it back. */
  function sending(on) {
    var fr = $("rfFrame"), box = fr && fr.parentNode, n = $("rfSending");
    if (!fr || !box) return;
    if (on) {
      if (!n) {
        n = document.createElement("p");
        n.id = "rfSending";
        n.className = "rfLoading";
        n.textContent = "Sending your request…";
        box.insertBefore(n, fr);
      }
      n.hidden = false;
      fr.style.display = "none";
      F.sendingOn = true;
    } else {
      if (n) n.hidden = true;
      fr.style.display = "";
      F.sendingOn = false;
    }
  }
  function onFrameLoad() {
    var fr = $("rfFrame"), s = fr ? fr.getAttribute("src") || "" : "";
    if (!s || s === "about:blank") return;
    var ld = $("rfLoading");
    if (ld) ld.hidden = true;
    fr.parentNode.classList.add("on");
    if (F.src !== s) { F.src = s; F.touched = false; F.first = Date.now(); return; }
    if (F.done || !(F.touched || Date.now() - F.first > 8000)) return;
    F.lastLoad = Date.now();
    clearTimeout(F.t);
    sending(true);
    F.t = setTimeout(function () { if (F.lastMsg < F.lastLoad) sent(); else sending(false); }, 1500);
  }
  function onMessage(ev) {
    var fr = $("rfFrame");
    if (!fr || ev.source !== fr.contentWindow) return;
    if (!/^https:\/\/([a-z0-9-]+\.)*jotform\.com$/.test(ev.origin)) return;
    F.lastMsg = Date.now();
    if (!F.done && F.sendingOn) { clearTimeout(F.t); sending(false); }
    var d = ev.data;
    if (typeof d === "string" && d.indexOf("setHeight:") === 0) {
      var h = parseInt(d.split(":")[1], 10);
      if (h > 200 && h < 20000) fr.style.height = h + 24 + "px";
    }
  }
  function sent() {
    if (F.done) return;
    F.done = true;
    try { sessionStorage.removeItem(FLAG); } catch (x) {}
    var S = St();
    S.req = [];
    S.draft = {};
    try { window.saveReq(); } catch (x) {}
    try { window.syncDock(); } catch (x) {}
    location.replace(THANKS);
  }
  function headText(send) {
    var h = document.querySelector("#rvaCat .rHead h1"), p = document.querySelector("#rvaCat .rHead .lede");
    if (h) {
      if (!F.h1) F.h1 = h.textContent;
      h.textContent = send ? "Send your request" : F.h1;
    }
    if (p) {
      if (!F.lede) F.lede = p.textContent;
      p.textContent = send ? "Add your name and email, attach your artwork if you have it, and send it with the button at the bottom. We reply with an invoice and your final price." : F.lede;
    }
  }
  function openSend() {
    var S = St();
    if (!S || !S.req.length || F.open) return;
    var w = buildSend(), main = $("reqPage") && $("reqPage").closest(".wrap"), fr = $("rfFrame");
    $("rfRecap").innerHTML = recapHTML();
    var u = frameURL();
    if (fr.getAttribute("src") !== u) {
      F.src = "";
      F.touched = false;
      sending(false);
      var ld = $("rfLoading");
      if (ld) ld.hidden = false;
      fr.style.height = "";
      fr.parentNode.classList.remove("on");
      fr.setAttribute("src", u);
      setTimeout(function () {
        fr.parentNode.classList.add("on");
        var l = $("rfLoading");
        if (l) l.hidden = true;
      }, 8000);
    }
    F.y = window.pageYOffset || 0;
    F.open = true;
    if (main) main.hidden = true;
    w.hidden = false;
    document.documentElement.classList.add("rfSending");
    headText(true);
    try { sessionStorage.setItem(FLAG, String(Date.now())); } catch (x) {}
    try { history.pushState({ rfSend: 1 }, ""); F.pushed = true; } catch (x) { F.pushed = false; }
    window.scrollTo(0, 0);
    var h = $("rfSendH");
    if (h) { try { h.focus({ preventScroll: true }); } catch (x) {} }
  }
  function closeSend(fromPop) {
    if (!F.open) return;
    F.open = false;
    var w = $("rfSendWrap"), main = $("reqPage") && $("reqPage").closest(".wrap");
    if (w) w.hidden = true;
    if (main) main.hidden = false;
    document.documentElement.classList.remove("rfSending");
    headText(false);
    try { sessionStorage.removeItem(FLAG); } catch (x) {}
    if (!fromPop && F.pushed) {
      F.pushed = false;
      try { history.back(); } catch (x) {}
    } else F.pushed = false;
    window.scrollTo(0, F.y);
  }
  function onSendClick(ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest("#send, #sendM") : null;
    if (!b || !isReq()) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    if (b.disabled) return;
    if (!zipOK()) {
      try { window.openForm(); } catch (x) {}
      return;
    }
    openSend();
  }

  var booted = false, tries = 0;
  function boot() {
    if (booted) return true;
    var S = St();
    if (!S || typeof window.drawSummary !== "function" || typeof window.repriceReq !== "function" || typeof window.submitURL !== "function") return false;
    if (!window.rvaF2Ready && tries < 120) return false;
    booted = true;
    try {
      wrap("drawSummary", function (f) {
        return function () {
          var r = f.apply(this, arguments);
          try { tidySummary(); } catch (e) { warn(e); }
          return r;
        };
      });
      window.rvaF2Note = tbdNote;
      tidySummary();
    } catch (e) { warn(e); }
    return true;
  }

  if (!isReq()) return;
  document.addEventListener("click", onSendClick, true);
  window.addEventListener("message", onMessage);
  window.addEventListener("blur", function () {
    setTimeout(function () { if (F.open && document.activeElement === $("rfFrame")) F.touched = true; }, 0);
  });
  window.addEventListener("popstate", function () { if (F.open) closeSend(true); });
  document.addEventListener("keydown", function (ev) {
    if (ev.key === "Escape" && F.open && document.activeElement !== $("rfFrame")) closeSend(false);
  });
  if (!boot()) {
    var iv = setInterval(function () {
      tries++;
      if (boot() || tries > 240) clearInterval(iv);
    }, 50);
  }
})();
